import { chat as en_chat } from "../en/chat";

/** chat — RU slice (79 keys). */
export const chat: Record<keyof typeof en_chat, string> = {
  chat_messages_title: "Сообщения",
  chat_messages_unread: "{count} непрочитанных",
  chat_messages_empty_title: "Сообщений пока нет",
  chat_messages_empty_description:
    "Когда у тебя появится взаимная симпатия, здесь можно начать общение",
  chat_messages_loading: "Загружаем сообщения...",
  chat_conversation_typing: "печатает...",
  chat_conversation_typing_multiple: "{count} человек печатают",
  chat_conversation_no_messages: "Сообщений пока нет",
  chat_conversation_no_messages_hint: "Напиши сообщение, чтобы начать общение",
  chat_conversation_edited: "изменено",
  chat_conversation_tap_to_retry: "Нажми, чтобы повторить",
  chat_input_placeholder: "Напиши сообщение...",
  chat_input_attachment_gallery: "Галерея",
  chat_input_attachment_camera: "Камера",
  chat_input_attachment_file: "Файл",
  chat_input_attachment_location: "Геопозиция",
  chat_input_replying_to: "Ответ для {name}",
  chat_attachment_photo: "Фото",
  chat_attachment_video: "Видео",
  chat_attachment_voice: "Голосовое сообщение",
  chat_attachment_file: "Файл",
  chat_attachment_location: "Геопозиция",
  chat_actions_reply: "Ответить",
  chat_actions_copy: "Копировать",
  chat_actions_edit: "Изменить",
  chat_actions_delete: "Удалить",
  chat_actions_forward: "Переслать",
  chat_conversation_actions_archive: "В архив",
  chat_conversation_actions_unarchive: "Из архива",
  chat_conversation_actions_mute: "Отключить звук",
  chat_conversation_actions_unmute: "Включить звук",
  chat_conversation_actions_pin: "Закрепить",
  chat_conversation_actions_unpin: "Открепить",
  chat_conversation_actions_delete: "Удалить",
  chat_conversation_actions_block: "Заблокировать",
  chat_time_just_now: "Только что",
  chat_time_yesterday: "Вчера",
  chat_delete_confirm_title: "Удалить сообщение",
  chat_delete_confirm_message: "Точно хочешь удалить это сообщение?",
  chat_delete_confirm_cancel: "Отмена",
  chat_delete_confirm_delete: "Удалить",
  chat_block_confirm_title: "Заблокировать пользователя",
  chat_block_confirm_message:
    "Точно хочешь заблокировать {name}? Тебе больше не смогут писать.",
  chat_block_confirm_cancel: "Отмена",
  chat_block_confirm_block: "Заблокировать",
  chat_error_send_failed: "Не удалось отправить сообщение",
  chat_error_load_failed: "Не удалось загрузить сообщения",
  chat_error_connection: "Соединение потеряно. Переподключаемся...",
  chat_options_title: "Опции",
  chat_options_leave_channel: "Покинуть канал",
  chat_options_leave_group: "Покинуть группу",
  chat_options_leaving: "Выходим...",
  chat_options_no_options: "Нет доступных опций",
  chat_leave_channel_title: "Покинуть канал?",
  chat_leave_channel_message:
    "Точно хочешь покинуть этот канал? Ты сможешь вернуться, если он публичный или если тебя снова пригласят.",
  chat_leave_group_title: "Покинуть группу?",
  chat_leave_group_message:
    "Точно хочешь покинуть эту группу? Ты сможешь вернуться, если она публичная или если тебя снова пригласят.",
  chat_leave_confirm_cancel: "Отмена",
  chat_leave_confirm_leave: "Выйти",
  chat_leave_error: "Не удалось покинуть {type}. Попробуй ещё раз.",
  chat_channel_admin_only: "Писать в этот канал могут только админы",
  chat_discover_title: "Найти каналы",
  chat_discover_invite_placeholder: "Введи код приглашения...",
  chat_discover_join_button: "Вступить",
  chat_discover_public_channels: "Публичные каналы",
  chat_discover_loading: "Загружаем каналы...",
  chat_discover_empty_title: "Каналы не найдены",
  chat_discover_empty_description:
    "Сейчас нет доступных публичных каналов. Загляни позже или вступай по ссылке-приглашению.",
  chat_discover_channel_members: "{count} участников",
  chat_discover_joining: "Вступаем...",
  chat_discover_join_error: "Не удалось вступить в канал. Попробуй ещё раз.",
  chat_discover_invite_error:
    "Неверный код приглашения или ты не можешь вступить в этот канал.",
  chat_discover_invite_empty_error: "Введи код приглашения.",
  chat_archive_error: "Не удалось архивировать переписку",
  chat_mute_error: "Не удалось отключить звук переписки",
  chat_pin_error: "Не удалось закрепить переписку",
  chat_delete_error: "Не удалось удалить переписку",
  chat_delete_conversation_title: "Удалить переписку?",
  chat_delete_conversation_message:
    "Точно хочешь удалить эту переписку? Это нельзя отменить.",
};
